module.exports = __webpack_public_path__ + "static/media/sriabida.a99b3318.png";